// @flow
import Experiment from '@homeaway/react-experiment';
import {SVGIcon} from '@homeaway/react-svg';
import {TOUR_360__24} from '@homeaway/svg-defs';
import debounce from 'lodash.debounce';
import React from 'react';

import {HA_SERP_VIRTUAL_TOUR_BADGE} from '../../abacus/experiments';
import {trigger, GENERIC_EVENT} from '../../utils/edapWrapper';

import './VirtualTourBadge.less';

import type {BadgeShape} from '../Hit/Hit';

const handleMouseEnter = debounce(() => {
    trigger(GENERIC_EVENT, {
        eventaction: 'hover virtual tour badge'
    });
}, 100);

export type Props = {
    badge: BadgeShape,
    detailPageUrl?: string,
    onBadgeClick?: Function
};

export function VirtualTourBadge(props: Props) {
    const {badge, detailPageUrl, onBadgeClick} = props;

    return (
        <Experiment name={HA_SERP_VIRTUAL_TOUR_BADGE}>
            {({On}) => (
                <On>
                    <a
                        className="VirtualTourBadge"
                        onMouseEnter={handleMouseEnter}
                        role="presentation"
                        target="_blank"
                        href={detailPageUrl}
                        onClick={onBadgeClick}
                        tabIndex="0"
                    >
                        <SVGIcon
                            markup={TOUR_360__24}
                            aria-hidden
                            className="VirtualTourBadge__icon"
                        />
                        <div className="VirtualTourBadge__text-container">
                            <span className="VirtualTourBadge__text">
                                {badge.name}
                            </span>
                        </div>
                    </a>
                </On>
            )}
        </Experiment>
    );
}
